import { render, staticRenderFns } from "./skilled-professionals.vue?vue&type=template&id=3881e70a&"
import script from "./skilled-professionals.vue?vue&type=script&lang=js&"
export * from "./skilled-professionals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports